<div class="eg-radio-select" *transloco="let translate">
  @for (item of items; track item) {
    <div
      class="eg-radio-select__item"
      [class.eg-radio-select__item--selected]="item.value === value"
      [class.eg-radio-select__item--disabled]="item.disabled"
      [fxFlex]="100 / items.length"
      fxLayout="row"
      fxLayoutAlign="center center"
      (click)="onItemSelect(item)"
    >
      <span>{{ translateLabel ? translate(item.label) : item.label }}</span>
    </div>
  }
</div>
